import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideUserIdleConfig } from 'angular-user-idle';
import {
  DialogContainerService,
  DialogService,
} from '@progress/kendo-angular-dialog';
import { NgxsModule } from '@ngxs/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { provideAnimations } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { ENVIRONMENT_TOKEN } from '../../../values/environment.token';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AssessmentListState } from './states/assessment-list.state';
import { auth0Interceptor } from '../../../../sdk/src/lib/interceptors/auth0.interceptor';
import { provideAuth0 } from '@auth0/auth0-angular';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([auth0Interceptor])),
    provideAuth0({
      domain: environment.auth0Domain,
      clientId: environment.auth0ClientId,
      authorizationParams: {
        redirect_uri: environment.auth0RedirectUri,
        audience: environment.auth0Audience,
        scope: environment.auth0Scope,
      },
    }),
    provideUserIdleConfig({ idle: 7200, timeout: 240, ping: 60 }),
    {
      provide: ENVIRONMENT_TOKEN,
      useValue: environment,
    },
    DialogService,
    DialogContainerService,
    importProvidersFrom(
      NgxsModule.forRoot([AssessmentListState]),
      NgxsReduxDevtoolsPluginModule.forRoot()
    ),
  ],
};
